
<span class="form-confirmation">
    <p class="form-confirmation">Leider ist ein Fehler bei der Übertragung aufgetreten.</p>    
    <p class="form-confirmation">Eine Benachrichtigung wurde an den Administrator gesendet. Für weitere Fragen wende dich bitte direkt unter office@wuenschmirwas.at</p>
</span>

